var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-5h24v24H-3z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2,
    height: 10.072,
    x: 0.4,
    y: 0.385,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.568.596L7.774 6.8 14.98.596"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxEmailIcon);
export default __webpack_public_path__ + "static/media/cx-email-icon.a671340bb53b8b95e38dffc86b7fa040.svg";
export { ForwardRef as ReactComponent };